import { useLayoutEffect, useRef, useState } from "react"
import { usePopper } from "react-popper"

type Placement =
  | 'auto'
  | 'auto-start'
  | 'auto-end'
  | 'top'
  | 'top-start'
  | 'top-end'
  | 'bottom'
  | 'bottom-start'
  | 'bottom-end'
  | 'right'
  | 'right-start'
  | 'right-end'
  | 'left'
  | 'left-start'
  | 'left-end';
interface Props {
  placement: Placement
  margin: number
}
const useDropdow = ({placement,margin}:Props) => {
  const[isOpen, setisOpen] = useState<boolean>(false)
  const [referenceElement, setReferenceElement] = useState<HTMLDivElement|null>(null)
  const [popperElement, setPopperElement] = useState<HTMLDivElement|null>(null)
  const refPopper = useRef<HTMLDivElement>(null)
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement,
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, margin],
        }
      }
    ]
  })

  useLayoutEffect(() => {
    const clickHandler = ({ target }: any) => {
      if (null !== refPopper.current) {
        if (!isOpen || refPopper.current.contains(target)) return;
        setisOpen(false);
      }
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });
  return {
    setReferenceElement,
    setPopperElement,
    styles,
    attributes,
    refPopper,
    isOpen,
    setisOpen
  }
}

export default useDropdow